import PageHeading from "./PageHeading";
import { Parallax } from "react-scroll-parallax";
import { useState, useContext } from "react";
import "../../../css/azienda.css";
import useFetch from "../../../hooks/useFetch";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import LanguageContext from "../../../context/language-context";
import BoxReveal from "../../UI/BoxReveal";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";

export default function Contract() {
  const [showFullText, setShowFullText] = useState(false);
  const [expandedItems, setExpandedItems] = useState([]);

  // State to keep track of the active index
  const [activeIndex, setActiveIndex] = useState(0);

  // Function to handle click on list items
  const handleItemClick = (index) => {
    setActiveIndex(index);
  };

  const toggleText = () => {
    setShowFullText(!showFullText);
  };
  const toggleText2 = (index) => {
    if (expandedItems.includes(index)) {
      setExpandedItems(
        expandedItems.filter((itemIndex) => itemIndex !== index)
      );
    } else {
      setExpandedItems([...expandedItems, index]);
    }
  };
  const translations = {
    en: {
      more: "Read More",
      less: "Read Less",
    },
    fr: {
      more: "Lire Plus",
      less: "Lire Moins",
    },
    de: {
      more: "Mehr Lesen",
      less: "Weniger Lesen",
    },
    ru: {
      more: "Читать далее",
      less: "Читать меньше",
    },
    es: {
      more: "Leer Más",
      less: "Leer Menos",
    },
    it: {
      more: "Leggi di più",
      less: "Leggi Meno",
    },
  };
  const languageCtx = useContext(LanguageContext);
  const { loading, error, data } = useFetch(
    `https://spagnoladmin.spagnolcompany.it/api/contracts?locale=${languageCtx.languageData}&populate[0]=Banner_Image&poopulate[1]=Contract_Item&populate[2]=Contract_Item.Inner_Image&poopulate[3]=Contract_Item.Inner_details.Big_Image&poopulate[4]=Contract_Item.Inner_details.Medium_Image&poopulate[5]=Contract_Item.Inner_details.Small_Image&populate[6]=Contract_Item.Front_Image&populate[7]=Contract_Item.Inner_details`
  );
  if (loading) return <p>Loading...</p>;
  const { data: details, meta } = data;
  return (
    <div className="mg-3">
      <PageHeading
        img={details[0].attributes.Banner_Image.data.attributes.url}
      />
      <div className="mission-text contract" data-scroll-section>
        <Parallax speed={3}>
          <BoxReveal
            children={
              <BlocksRenderer
                content={details[0].attributes.Intro_Text}
                blocks={{
                  paragraph: ({ children }) => (
                    <p className="mt-4 text-base lg:text-xl">{children}</p>
                  ),
                  heading: ({ children, level }) => {
                    const Tag = `h${level}`;
                    return (
                      <Tag className="mt-4 font-bold text-base lg:text-2xl">
                        {children}
                      </Tag>
                    );
                  },
                  list: ({ children, format }) =>
                    format === "unordered" ? (
                      <ul className="list-disc list-inside ml-6 mt-4">
                        {children}
                      </ul>
                    ) : (
                      <ol className="list-decimal list-inside ml-6 mt-4">
                        {children}
                      </ol>
                    ),
                  quote: ({ children }) => (
                    <blockquote className="border-l-4 border-gray-300 pl-4 font-extrabold text-2xl text-black mt-4 w-[80%]">
                      {children}
                    </blockquote>
                  ),
                  link: ({ children, url }) => (
                    <Link to={url} className="text-footer underline">
                      {children}
                    </Link>
                  ),
                }}
              />
            }
            boxColor={"#fff"}
          />
        </Parallax>
      </div>
      <div className="first-section">
        <div className="section-inner contract">
          {details[0].attributes.Contract_Item.map((item, index) => {
            return (
              <div className="right-text curve image" key={index}>
                <Parallax speed={3}>
                  <div className="hovereffect">
                    <a
                      className="test curve"
                      href={`/contract/${item.Title.toLowerCase()}`}
                    >
                      <img
                        src={`https://spagnoladmin.spagnolcompany.it${item.Front_Image.data.attributes.url}`}
                      />
                    </a>
                  </div>
                </Parallax>
                <div className="txt">
                  <p className="t-medium">{item.Title}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
